import {useState, useCallback} from 'react';

function useUpdate() {
    const [, setTick] = useState(0);
    const update = () => {
        setTick(tick => tick + 1);
    };
    return useCallback(update, []);
}

export default useUpdate;